import * as React from "react";
import PropTypes from "prop-types";
const SvgActivitySegmentNormalXsmall = React.forwardRef(
  ({ color = "currentColor", size = 16, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M5.286 12.4c.56.879 1.12 1.63 1.54 2.161.374.475.771.926 1.174 1.377.402-.45.8-.902 1.174-1.377.42-.531.98-1.282 1.54-2.16C11.816 10.674 13 8.34 13 6.191c0-1.736-.643-3.051-1.618-3.926C10.419 1.402 9.172 1 8 1s-2.42.402-3.382 1.266C3.643 3.14 3 4.456 3 6.192c0 2.15 1.184 4.483 2.286 6.208zm.167-9.204C6.161 2.561 7.1 2.25 8 2.25s1.84.311 2.547.946c.694.623 1.203 1.592 1.203 2.996 0 1.765-1.004 3.836-2.09 5.536a25.776 25.776 0 01-1.66 2.3c-.06-.073-.124-.154-.193-.24-.4-.509-.935-1.226-1.468-2.06-1.085-1.7-2.089-3.77-2.089-5.536 0-1.404.509-2.373 1.203-2.996z"
        fill=""
      />
    </svg>
  )
);
SvgActivitySegmentNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgActivitySegmentNormalXsmall;
